import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

const list = Object.freeze([
  {
    id: '0',
    value: 'NO',
  },
  {
    id: '1',
    value: 'SI',
  },
]);

interface ListYesNoProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  expatriationBan?: boolean;
  error?: boolean;
  label: string;
}

const ListYesNoComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  expatriationBan,
  label,
}: ListYesNoProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`label-${label}`}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list
          .filter((item) => (expatriationBan ? item.id === '0' : true))
          .map((item: ItemVM) => (
            <MenuItem key={item.id} value={item.id}>
              {item.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListYesNoComponent.displayName = 'List yes or no component';

const ListYesNo = memo(ListYesNoComponent);

export default ListYesNo as typeof ListYesNoComponent;
